import React, {useState, useRef, useEffect} from 'react';
import post from '../utils/post.js';
import FormText from './FormText.js';
import usePopupAnimation from '../utils/usePopupAnimation.js';

export default function LinksNew({showNew, closeNew, updateLinksRowNew}) {
	const popupAnimationMs = 300;
	const [loading, setLoading] = useState(false);
	const [name, setName] = useState('');
	const [URL, setURL] = useState('');
	const [groupName, setGroupName] = useState('');
	const [nameError, setNameError] = useState('');
	const [URLError, setURLError] = useState('');
	const [groupNameError, setGroupNameError] = useState('');

	const nameRef = useRef(null);
	const URLRef = useRef(null);
	const groupNameRef = useRef(null);
	const {shouldRender, isClosing} = usePopupAnimation(showNew, popupAnimationMs);

	useEffect(() => {
		setName('');
		setURL('');
		setGroupName('');
	}, [showNew]);

	const handleSubmit = (e) => {
		e.preventDefault();

		setNameError('');
		setURLError('');
		setGroupNameError('');

		let localError = 0;

		if (!name) {
			localError = 1;
			setNameError('povinné');
			nameRef.current.focus();
		}

		if (localError === 0) {
			setLoading(true);

			post('saveLinksNew', {NAME: name, URL: URL, GROUPNAME: groupName})
				.then((res) => {
					closeNew();

					if (res.ID > 0) {
						updateLinksRowNew({ID: res.ID, NAME: name, URL: URL, GROUPNAME: groupName});
					}

					setLoading(false);
				})
				.catch((error) => {
					console.error(error);
					setLoading(false);
				});
		}
	};

	return (
		<>
			{shouldRender ? (
				<div className={`popup${isClosing ? ' popup--closing' : ''}`}>
					<div className={`popup_content${isClosing ? ' popup_content--closing' : ''}`}>
						<form method="POST" onSubmit={handleSubmit}>
							<div className="popup_content_in_head">
								<div className="popup_content_in_head_in">Nový odkaz</div>
								<img
									alt=""
									className="popup_content_in_head_in-close"
									onClick={() => {
										closeNew();
									}}
								/>
							</div>
							<div className="popup_content_in_body">
								<div className="popup_content_in_body_in">
									<FormText type="text" label="Název" height="25rem" value={name} setValue={setName} ref={nameRef} error={nameError} />
									<FormText type="text" label="URL" height="25rem" value={URL} setValue={setURL} ref={URLRef} error={URLError} />
									<FormText type="text" label="Skupina odkazů" height="25rem" value={groupName} setValue={setGroupName} ref={groupNameRef} error={groupNameError} />
									<div className="zero h0" />
								</div>
							</div>
							<div className="popup_content_in_foot">
								<div className="popup_content_in_foot_in">
									<input type="submit" name="button_save" value="Uložit" className="button green mr_2" disabled={loading} />
									<button
										type="button"
										className="button"
										onClick={() => {
											closeNew();
										}}
									>
										Zpět
									</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			) : (
				''
			)}
		</>
	);
}
